// extracted by css-extract-rspack-plugin
export default {"pill":"MultiAutocomplete-module__pill___uQbAz","field":"MultiAutocomplete-module__field___kx5Qj"};